import {
    FETCH_PAYMENT_METHODS,
    FETCH_PAYMENT_METHODS_SUCCESS,
    FETCH_PAYMENT_METHODS_FAILED,
    UPDATE_WALLET_BALANCE,
    UPDATE_WALLET_BALANCE_SUCCESS,
    UPDATE_WALLET_BALANCE_FAILED,
    CLEAR_PAYMENT_MESSAGES
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { push } from "firebase/database";

export const fetchPaymentMethods = () => (dispatch) => {
   
    const {
        config
    } = firebase;
 
    dispatch({
        type: FETCH_PAYMENT_METHODS,
        payload: null,
    });
    
    // CORS fix: prefer same-origin so the panel custom domain works via Hosting rewrites.
    let host = (typeof window !== 'undefined' && window.location && window.location.origin) ? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/get_providers`;
    fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    })
        .then((response) => response.json())
        .then((responseJson) => {
            if (responseJson.length > 0) {
                dispatch({
                    type: FETCH_PAYMENT_METHODS_SUCCESS,
                    payload: responseJson,
                });
            }else{
                dispatch({
                    type: FETCH_PAYMENT_METHODS_FAILED,
                    payload: store.getState().languagedata.defaultLanguage.no_provider_found,
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: FETCH_PAYMENT_METHODS_FAILED,
                payload: store.getState().languagedata.defaultLanguage.provider_fetch_error + ": " + error.toString(),
            });
        });
};

export const clearMessage = () => (dispatch) => {
    dispatch({
        type: CLEAR_PAYMENT_MESSAGES,
        payload: null,
    });    
};


// sec-wallet-server-side: this used to read the user's walletBalance on the
// client, add `amount`, and write it back via update(walletBalance) — a racy
// read-modify-write where the new balance was computed client-side. The math
// (and the walletHistory + push notification) now runs entirely server-side in
// the admin-only /admin_credit_wallet endpoint, which mutates the balance via an
// atomic RTDB transaction. The client only sends {uid, amount} + a Bearer token.
export const addToWallet = (uid, amount) => async (dispatch) => {
    const { config, auth } = firebase;

    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    try {
        const user = auth && auth.currentUser;
        if (!user) {
            throw new Error('Not authenticated');
        }
        const token = await user.getIdToken();
        const host = (typeof window !== 'undefined' && window.location && window.location.origin)
            ? window.location.origin
            : `https://${config.projectId}.web.app`;
        const res = await fetch(`${host}/admin_credit_wallet`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            },
            body: JSON.stringify({ uid, amount: parseFloat(amount) }),
        });
        const json = await res.json().catch(() => ({}));
        if (res.ok && json && json.ok) {
            dispatch({
                type: UPDATE_WALLET_BALANCE_SUCCESS,
                payload: null
            });
        } else {
            dispatch({
                type: UPDATE_WALLET_BALANCE_FAILED,
                payload: (json && json.error) ? json.error : `HTTP ${res.status}`,
            });
        }
    } catch (error) {
        dispatch({
            type: UPDATE_WALLET_BALANCE_FAILED,
            payload: error.message || String(error),
        });
    }
};


export const withdrawBalance = (profile, amount) => async (dispatch) => {

    const {
        withdrawRef,
    } = firebase;
    
    dispatch({
        type: UPDATE_WALLET_BALANCE,
        payload: null
    });

    push(withdrawRef, {
        uid : profile.uid,
        name : profile.firstName +  ' ' + profile.lastName,
        amount : parseFloat(amount),
        date : new Date().getTime(),
        bankName : profile.bankName? profile.bankName : '',
        bankCode : profile.bankCode? profile.bankCode : '',
        bankAccount : profile.bankAccount? profile.bankAccount : '',
        processed:false
    });
       
};
